import common from './common.json';
import debug from './debug.json';
import dialogs from './dialogs.json';
import errors from './errors.json';
import nodes from './nodes.json';
import panels from './panels.json';
import simulator from './simulator.json';

export default {
  common,
  debug,
  dialogs,
  errors,
  nodes,
  panels,
  simulator,
};
